export default "__VITE_ASSET__BnoRN4HO__"